import PriceFormat from "../../../../utils/priceFormat";
import CurrencyInput from "./CurrencyInput";

export default function CompactEditableValue({
  label,
  value,
  isEditing,
  inputValue,
  onInputChange,
  onStartEdit,
  onSave,
  onCancel,
}: {
  label: string;
  value: number | null;
  isEditing: boolean;
  inputValue: string;
  onInputChange: (value: string) => void;
  onStartEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-[9px] uppercase tracking-wider text-gray-400">{label}</span>

      {isEditing ? (
        <CurrencyInput
          value={inputValue}
          onChange={onInputChange}
          onSave={onSave}
          onCancel={onCancel}
          inputClassName="w-16 rounded border border-primary-300 px-1 py-0 text-[11px] font-semibold text-gray-900 focus:border-primary-500 focus:ring-primary-500"
          poundClassName="text-[9px] font-bold text-gray-400"
          saveIconClassName="h-2.5 w-2.5"
        />
      ) : (
        <button
          type="button"
          onClick={onStartEdit}
          className="text-[11px] font-semibold text-gray-600 transition-colors hover:text-primary-600"
        >
          {value != null ? (
            PriceFormat(value)
          ) : (
            <span className="text-gray-400 underline decoration-dashed underline-offset-2">Add</span>
          )}
        </button>
      )}
    </div>
  );
}